import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import { useWindowDimensions } from '../../util/hooks';

const Sidebar = ({
    categories,
    filterPosts,
    setSearchQuery,
    filterCategories,
    resetFilterCategories,
    regions
}) => {
    const [showFilters, setShowFilters] = useState(
        useWindowDimensions().width < 1024 ? false : true
    );

    const [showType, setShowType] = useState(true);
    const [showRegions, setShowRegions] = useState(true);

    useEffect(() => {
        function handleResize() {
            setShowFilters(useWindowDimensions().width < 1024 ? false : true);
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <>
            <div className="grid justify-between grid-cols-3 py-4 font-medium lg:mb-6 lg:border-b lg:hidden border-purple-midnight border-opacity-20 lead">
                <div
                    className="inline-flex items-center"
                    onClick={() => setShowFilters(!showFilters)}
                >
                    <i className="mr-2 en-filter"></i> Filter
                </div>
                <a
                    href=""
                    onClick={(ev) => {
                        ev.preventDefault();

                        setSearchQuery('');
                        filterPosts([]);
                        resetFilterCategories();
                    }}
                    className="items-center block mx-auto text-purple-midnight"
                >
                    Clear All
                </a>
            </div>
            <Transition
                show={showFilters}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                className="lg:block fixed lg:static top-0 lg:top-24 left-0 lg:z-0 z-[101] w-full h-screen lg:h-auto p-6 lg:p-0 lg:overflow-hidden overflow-auto bg-white pb-32 lg:pb-0"
            >
                <div className="flex items-center justify-between mb-12 lg:block">
                    <h5 className="mb-0 lg:pb-6 lg:mb-16 lg:border-b border-purple-midnight border-opacity-20">
                        Filter
                    </h5>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            setShowFilters(false);
                        }}
                        className="flex items-center font-medium lead opacity-80 hover:opacity-100 text-purple-midnight lg:hidden"
                    >
                        <span className="min-w-[42px]">Close</span>
                        <span
                            className={`icon-expaded relative h-6 w-6 flex-col justify-between items-center flex ml-3`}
                        >
                            <span
                                className={`absolute inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`relative top-0 inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`relative bottom-0 inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                            <span
                                className={`absolute bottom-0 inline-block w-1 h-1 rounded-10 bg-purple-midnight`}
                            ></span>
                        </span>
                    </a>
                </div>
                <div className="hidden mb-12 lg:block">
                    <a
                        href="#"
                        onClick={(ev) => {
                            ev.preventDefault();

                            setSearchQuery('');
                            filterPosts([]);
                            resetFilterCategories();
                        }}
                        className="border-b opacity-50 lead text-purple-midnight border-purple-midnight "
                    >
                        Clear All
                    </a>
                </div>

                <div>
                    <div className="mb-16 last:mb-4">
                        <p
                            onClick={() => setShowType(!showType)}
                            className="flex items-center justify-between pb-6 mb-6 border-b cursor-pointer lead lead--large border-purple-midnight border-opacity-20"
                        >
                            Type
                            <i className="transform rotate-180 en-caret-down opacity-20 text-10 "></i>
                        </p>
                        <Transition show={showType}>
                            <div className="flex flex-col items-start space-y-2">
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();

                                        filterPosts([]);
                                        resetFilterCategories();
                                    }}
                                    className={`cursor-pointer btn btn--light ${
                                        !filterCategories.length
                                            ? 'btn--light--on'
                                            : ''
                                    }`}
                                >
                                    All
                                </span>
                                {categories &&
                                    categories.map((category, index) => (
                                        <span
                                            onClick={(e) => {
                                                e.preventDefault();
                                                filterPosts(category.slug);
                                            }}
                                            className={`btn cursor-pointer btn--light ${
                                                filterCategories.includes(
                                                    category.slug
                                                )
                                                    ? 'btn--light--on'
                                                    : ''
                                            }`}
                                            key={index}
                                        >
                                            {category.name}
                                        </span>
                                    ))}
                            </div>
                        </Transition>
                    </div>
                    <div className="mb-16 last:mb-4">
                        <p
                            onClick={() => setShowRegions(!showRegions)}
                            className="flex items-center justify-between pb-6 mb-6 border-b cursor-pointer lead lead--large border-purple-midnight border-opacity-20"
                        >
                            Regions
                            <i className="transform rotate-180 en-caret-down opacity-20 text-10 "></i>
                        </p>
                        <Transition show={showRegions}>
                            <div className="flex flex-col items-start space-y-2">
                                <span
                                    onClick={(e) => {
                                        e.preventDefault();

                                        filterPosts([]);
                                        resetFilterCategories();
                                    }}
                                    className={`cursor-pointer btn btn--light ${
                                        !filterCategories.length
                                            ? 'btn--light--on'
                                            : ''
                                    }`}
                                >
                                    All
                                </span>
                                {regions &&
                                    regions.map((region, index) => (
                                        <span
                                            onClick={(e) => {
                                                e.preventDefault();
                                                filterPosts(region.slug);
                                            }}
                                            className={`btn cursor-pointer btn--light ${
                                                filterCategories.includes(
                                                    region.slug
                                                )
                                                    ? 'btn--light--on'
                                                    : ''
                                            }`}
                                            key={index}
                                        >
                                            {region.name}
                                        </span>
                                    ))}
                            </div>
                        </Transition>
                    </div>
                </div>

                <div className="fixed bottom-0 left-0 flex items-center w-full gap-4 px-6 py-4 bg-white border-t lg:hidden border-purple-midnight border-opacity-20">
                    <a
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            setSearchQuery('');
                            filterPosts([]);
                            resetFilterCategories();
                            setShowFilters(!showFilters);
                        }}
                        className="w-full btn btn--o-midnight"
                    >
                        Clear All
                    </a>
                    <a
                        href=""
                        onClick={(e) => {
                            e.preventDefault();
                            setShowFilters(!showFilters);
                        }}
                        className="w-full btn btn--midnight"
                    >
                        Apply
                    </a>
                </div>
            </Transition>
        </>
    );
};

export default Sidebar;
